import tracking from '@g4/g4-analytics';
import moment from '@g4/moment-utc';

import { generateAnalyticsData } from '../../utils';

export const getRawProducts = (hotel, room, position) => {
  const {
    hotel_destination: hotelDestination,
    hotel_number_of_adults: adultsCount,
    hotel_check_in_date: hotelCheckInDate,
    hotel_check_out_date: hotelCheckOutDate,
    hotel_total_number_of_rooms: hotelNumberOfRooms,
    hotel_number_of_children: childrenCount,
    hotel_total_number_of_guests: hotelTotalNumberOfGuests,
  } = generateAnalyticsData();

  const bookingDaysOut = moment(hotelCheckInDate).diff(moment(), 'days');
  const dateIn = moment(hotelCheckInDate).format('YYYY-MM-DD');
  const dateOut = moment(hotelCheckOutDate).format('YYYY-MM-DD');
  const item = room ? room : hotel;

  return {
    item_id: hotel?.id,
    item_name: hotel?.name,
    coupon: '',
    discount: '',
    index: position,
    item_brand: 'G4',
    item_category: '3rd Party/Hotels',
    item_category2: item?.name,
    item_category3: 'D',
    item_category4: hotelDestination,
    item_category5: 'Hotel',
    item_variant: `${item?.id}-${item?.name}`,
    price: item?.prices?.dailyAverageRate,
    quantity: hotelNumberOfRooms ?? 1,
    item_promotion_name: '',
    item_promotion_id: '',
    item_partial_reservation: '',
    item_booking_start: dateIn || '',
    item_booking_end: dateOut || '',
    item_booking_days_out: bookingDaysOut,
    item_count_child: childrenCount,
    item_count_adult: adultsCount,
    item_count_total: hotelTotalNumberOfGuests,
    item_focus_city: hotelDestination,
    item_market_type: '',
    item_credit_applied: '',
    item_haul: '',
    affiliation: 'WWW-HLO',
  };
};

export const getHotelPromoData = (
  index,
  hotel,
  promo,
  destination,
  hotelName
) => {
  return {
    creative: promo?.code,
    name: promo?.shortDescription,
    position: index,
    id: promo.id,
    items: [
      {
        item_id: hotel?.id,
        item_name: hotelName,
        coupon: promo?.code,
        discount: promo?.code,
        index: index,
        item_brand: 'G4',
        item_category: '3rd Party/Hotels',
        item_category2: hotel?.name,
        item_category3: 'D',
        item_category4: destination,
        item_category5: 'Hotel',
        item_variant: `${hotel?.id}-${hotel?.name}`,
        price: hotel?.prices?.dailyAverageRate,
        quantity: 1,
        promotion_name: promo?.shortDescription,
        promotion_id: promo.id,
        affiliation: 'WWW-HLO',
      },
    ],
  };
};

export const trackPromoClickEvent = (
  promo,
  index,
  hotel,
  destination,
  hotelName
) => {
  tracking.trackPromoSelect(
    getHotelPromoData(index, hotel, promo, destination, hotelName)
  );
};

export const getHotelOrderDetails = hotelItem => {
  const {
    hotel_destination: hotelDestination,
    hotel_id: hotelId,
  } = generateAnalyticsData();

  const hotelCheckInTime = moment(hotelItem.checkin.time);
  const bookingDaysOut = hotelCheckInTime.diff(moment(), 'days');
  const checkin = hotelCheckInTime.format('YYYY-MM-DD');
  const checkout = moment(hotelItem.checkout.time).format('YYYY-MM-DD');

  const hotelInfo = JSON.parse(
    window.localStorage.getItem('cachedAnalyticsData')
  );
  const id = hotelId ? hotelId : hotelInfo?.hotelId;
  const destination = hotelDestination
    ? hotelDestination
    : hotelInfo?.destination;

  return {
    item_id: id,
    item_name: hotelItem.hotel.name,
    index: 1,
    item_brand: 'G4',
    item_category: '3rd Party/Hotels',
    item_category2: hotelItem.hotel.name,
    item_category3: 'D',
    item_category4: destination,
    item_category5: 'Hotel',
    item_variant: hotelItem.roomType,
    price: hotelItem.price.subtotal,
    quantity: hotelItem.roomsCount ?? 1,
    item_promotion_name: '',
    item_promotion_id: '',
    item_partial_reservation: '',
    item_booking_start: checkin || '',
    item_booking_end: checkout || '',
    item_booking_days_out: bookingDaysOut,
    item_count_child: hotelItem.childrenCount,
    item_count_adult: hotelItem.adultCount,
    item_count_total: hotelItem.adultCount + hotelItem.childrenCount,
    item_focus_city: destination,
    item_market_type: '',
    item_credit_applied: '',
    item_haul: '',
    affiliation: 'WWW-HLO',
  };
};
